// @ts-expect-error TS(7016)
import { createReconnectableIframe } from "@livechat/postmessage";

import { INormalizedInboxMessage, IOutboxMessage, denormalizeInboxMessage, normalizeOutboxMessage } from "../message";

import { CONNECTION_MISSING_ERROR_MESSAGE, IConnection, IInboxMessageSubscriber } from "./connection";
import { createSubscriberNotifier } from "./helpers";

interface ITrustedConnectionOptions {
  onReconnect?(): void;
}

export async function createTrustedConnection(
  iframe: HTMLIFrameElement,
  options: ITrustedConnectionOptions = {}
): Promise<IConnection> {
  const connectionId = String(Math.random());
  const subscribers = new Set<IInboxMessageSubscriber>();
  const notifySubscribers = createSubscriberNotifier(subscribers);

  const handleMessage = (message: INormalizedInboxMessage): void => {
    notifySubscribers(denormalizeInboxMessage(message), connectionId);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let connection: any;

  // Wait for first connection
  await new Promise(resolve => {
    createReconnectableIframe(
      {
        frame: iframe,
        targetOrigin: "*",
        handshakeRetry: {
          interval: 500,
          count: 20,
        },
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onConnected: (c: any) => {
          if (!connection) {
            // @ts-expect-error TS(2794): Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
            resolve();
          } else if (options.onReconnect) {
            options.onReconnect();
          }
          connection = c;
        },
      },
      { handle: handleMessage }
    );
  });

  return {
    connectionId,
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    initialize() {
      // No initialization logic needed, all is handled by the SDK.
    },
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    subscribe(subscriber: IInboxMessageSubscriber) {
      subscribers.add(subscriber);
    },
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    unsubscribe(subscriber: IInboxMessageSubscriber) {
      subscribers.delete(subscriber);
    },
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    send(message: IOutboxMessage) {
      if (connection) {
        return connection.call("handle", normalizeOutboxMessage(message));
      }
      return Promise.reject(new Error(CONNECTION_MISSING_ERROR_MESSAGE));
    },
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    setContext(context) {
      // @ts-expect-error TS(2339): Property 'msgContext' does not exist on type 'ICon... Remove this comment to see the full error message
      this.msgContext = context;
    },
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    getContext() {
      // @ts-expect-error TS(2339): Property 'msgContext' does not exist on type 'ICon... Remove this comment to see the full error message
      return this.msgContext || {};
    },
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    destroy() {
      connection.destroy();
      subscribers.clear();
    },
  };
}
